<template>
    <div class="container mt-nav z-index">
        <Head title="خرید دوره"/>
        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto">
                <div class="box__information">
                    <template v-if="payment.status === 'success'">
                        <div class="col-12">
                            <div class="success__icon">
                                <div class="success__icon-img">
                                    <img src="/front/assets/images/success.png" alt="">
                                    <p class="m-0 success__icon-text">پرداخت شما با موفقیت انجام شد</p>
                                </div>
                            </div>


                            <div class="text__information mt-0 mt-sm-4">
                                <template v-if="packages.diet">
                                    <div class="position-relative">
                                        <p class="m-0 text-light text-md">بسته خریداری شده</p>
                                        <div class="dashed"></div>
                                        <p class="m-0 text-light text-md">{{ packages.diet.title }}</p>
                                    </div>
                                </template>

                                <template v-if="packages.support">
                                    <div class="position-relative">
                                        <p class="m-0 text-light text-md">بسته پشتیبان</p>
                                        <div class="dashed"></div>
                                        <p class="m-0 text-light text-md">{{ packages.support.title }}</p>
                                    </div>
                                </template>

                                <div class="position-relative">
                                    <p class="m-0 text-light text-md">شناسه پرداخت</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-light text-md">{{ payment.code }}</p>
                                </div>

                                <div class="position-relative">
                                    <p class="m-0 text-light text-md">شناسه بانک</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-light text-md">{{ payment.authority }}</p>
                                </div>

                                <div class="position-relative">
                                    <p class="m-0 text-success  fs-3 text-md">مبلغ پرداختی</p>
                                    <div class="dashed"></div>
                                    <p class="m-0 text-success  fs-3 text-md">
                                        {{ new Intl.NumberFormat('ar-EG').format(payment.cost) }} تومان</p>
                                </div>
                                <div class="d-flex justify-content-center"><a href="profile/request_diet"
                                                                              class="btn btn-orange w-100-btn">ورود به
                                    پروفایل و دریافت رژیم</a></div>

                            </div>
                        </div>
                    </template>
                    <template v-if="payment.status === 'none' || payment.status === 'unsuccessful'">
                        <div class="col-12">

                            <template v-if="payment.status === 'unsuccessful'">
                                <div class="unsuccess__icon">
                                    <div class="unsuccess__icon-img">
                                        <img src="/front/assets/images/un-success.png" alt="">
                                        <p class="m-0 unsuccess__icon-text">{{ payment.message }}</p>

                                    </div>
                                </div>
                            </template>
                            <template v-if="packages.total > 0">
                                <div v-if="payment.status === 'unsuccessful'" class="alert alert-custom text-center m-2"
                                     role="alert">
                                    در صورت کم شدن مبلغ از حساب شما حداکثر تا ۷۲ ساعت اینده مبلغ مجدد به حساب شما بازگشت
                                    داده خواهد شد
                                    <div class="text__information mt-0 mt-sm-4">
                                        <div class="position-relative">
                                            <p class="m-0 text-light text-md">شناسه پرداخت</p>
                                            <div class="dashed"></div>
                                            <p class="m-0 text-light text-md">{{ payment.code }}</p>
                                        </div>
                                        <div class="position-relative">
                                            <p class="m-0 text-light text-md">شناسه بانک</p>
                                            <div class="dashed"></div>
                                            <p class="m-0 text-light text-md">{{ payment.authority }}</p>
                                        </div>
                                    </div>
                                </div>

                                <div v-else class="alert alert-custom text-center m-2" role="alert">
                                    لطفا اطلاعات پیش فاکتور خود را چک و برای نهایی شدن روی کلید پرداخت آنلاین کلیک کنید
                                </div>
                            </template>

                            <template v-if="packages.total === 0 && packages.paymentByCouponOrWallet !== true">
                                <div class="unsuccess__icon">
                                    <div class="unsuccess__icon-img">
                                        <img src="/front/assets/images/un-success.png" alt="">
                                        <p class="m-0 unsuccess__icon-text">هیچ پکیجی انتخاب نشده است</p>
                                    </div>
                                </div>
                                <p class="m-0 text-light text-md text-center">لطفا یک پکیج برای خرید انتخاب کنید</p>
                                <div class="pt-5 text-center">
                                    <Link class="flex items-center btn btn-orange w-100-btn" href="/packages">انتخاب
                                        بسته
                                    </Link>
                                </div>
                                <div class="pt-3 text-center">
                                    <a class="btn btn-outline-orange hover_button w-100-btn mx-auto" href="profile">بازگشت
                                        به پروفایل</a>

                                </div>
                            </template>
                            <template v-else>
                                <div class="text__information mt-0 mt-sm-4">
                                    <template v-if="packages.diet">
                                        <div class="position-relative">
                                            <p class="m-0 text-light text-md">بسته انتخابی</p>
                                            <div class="dashed"></div>
                                            <p class="m-0 text-light text-md">{{ packages.diet.title }}</p>
                                        </div>
                                        <div class="position-relative">
                                            <p class="m-0 text-light text-md">هزینه بسته</p>
                                            <div class="dashed"></div>
                                            <p class="m-0 text-light text-md">
                                                {{ new Intl.NumberFormat('ar-EG').format(packages.diet.price) }}
                                                تومان</p>
                                        </div>
                                    </template>
                                    <template v-if="packages.support">
                                        <div class="position-relative">
                                            <p class="m-0 text-light text-md">بسته پشتیبان</p>
                                            <div class="dashed"></div>
                                            <p class="m-0 text-light text-md">{{ packages.support.title }}</p>
                                        </div>

                                        <div class="position-relative">
                                            <p class="m-0 text-light text-md">هزینه پشتیبانی اختصاصی</p>
                                            <div class="dashed"></div>
                                            <p class="m-0 text-light text-md">
                                                {{ new Intl.NumberFormat('ar-EG').format(packages.support.price) }}
                                                تومان</p>
                                        </div>
                                    </template>
                                    <div class="position-relative">
                                        <p class="m-0 text-warning   text-md">میزان شارژ حساب شما</p>
                                        <div class="dashed"></div>
                                        <p class="m-0 text-warning   text-md">
                                            {{ new Intl.NumberFormat('ar-EG').format(packages.wallet_before_payment) }}
                                            تومان</p>
                                    </div>

                                    <template v-if="discountCode">
                                        <div class="position-relative">
                                            <p class="m-0 text-danger  fs-3 text-md">کد تخفیف ({{ discountCode }}) </p>
                                            <div class="dashed"></div>
                                            <p class="m-0 text-danger  fs-3 text-md">
                                                {{
                                                    new Intl.NumberFormat('ar-EG').format(packages.discount_code)
                                                }}{{ packages.discount_type === 'fixed_amount' ? ' تومان' : '٪ تخفیف' }}
                                            </p>
                                        </div>
                                    </template>

                                    <div class="position-relative">
                                        <p class="m-0 text-danger  fs-3 text-md">تخفیف کل </p>
                                        <div class="dashed"></div>
                                        <p class="m-0 text-danger  fs-3 text-md">
                                            {{ new Intl.NumberFormat('ar-EG').format(packages.total_discount) }}
                                            تومان</p>
                                    </div>
                                    <div class="position-relative">
                                        <p class="m-0 text-success  fs-3 text-md">مبلغ قابل پرداخت</p>
                                        <div class="dashed"></div>
                                        <p class="m-0 text-success  fs-3 text-md">
                                            {{ new Intl.NumberFormat('ar-EG').format(packages.total) }} تومان</p>
                                    </div>
                                    <template v-if="discountCode === null && packages.total > 0">
                                        <form @submit.prevent="storeDiscount">
                                            <p class="m-0 text-light text-md">در صورتی که کد تخفیف دارد وارد کنید</p>
                                            <div class="d-flex flex-row">
                                                <div class="flex-grow-1">
                                                    <text-input style="border-radius : 0 9px 9px 0 !important"
                                                                ref="firstName" v-model="formDiscount.code"
                                                                :error="formDiscount.errors.payment" class="my-3"
                                                                placeHolder="کد تخفیف"/>
                                                </div>
                                                <div class="pt-3 ">
                                                    <discount-button :loading="formDiscount.processing"
                                                                     class="tn border-0 btn-orange w-100-btn"
                                                                     type="submit">اعمال
                                                    </discount-button>
                                                </div>
                                            </div>
                                        </form>
                                    </template>
                                </div>
                            </template>
                            <template v-if="data && data.action && data.inputs && data.inputs.Token">

                                <form id="sebForm" method="post" :action="data.action" class="d-none">
                                        <input name="Token" :value="data.inputs.Token" type="text">
                                        <input name="GetMethod" value="true" type="text">
                                        <input type="submit">
                                </form>
                            </template>

                            <div v-if="redirect" class="pt-4">
                                <p class="text-sm text-white text-center"> لطفا کمی صبر کنید تا به درگاه متصل شوید . .
                                    .</p>
                                <div class="text-sm text-white text-center">
                                    <div class="spinner-grow text-danger" role="status">
                                    </div>
                                </div>
                            </div>
                            <div v-else class="mt-5 text-center">
                                <div v-if="form.errors.payment" class="form-error"><p
                                    class="m-0 fs-4 text-sm text-error mb-3">{{ form.errors.payment }}</p></div>

                                <form @submit.prevent="storeOnlinePayment" v-if="(packages.total > 0 ) || ( packages.paymentByCouponOrWallet)">
                                    <loading-button :loading="form.processing" class="btn btn-orange w-100-btn"
                                                    type="submit">
                                        {{ packages.total === 0 ? 'پرداخت با استفاده از موجودی' : 'پرداخت آنلاین' }}
                                    </loading-button>
                                </form>

                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {Head, Link} from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "..//Shared/Layouts/LayoutFirstRegister";
import TextInput from "../Shared/Forms/TextInput";
import DiscountButton from "../Shared/Layouts/DiscountButton";
import LoadingButton from "../Shared/Layouts/LoadingButton";

export default {
    props: ['name', 'redirect', 'packages', 'discountCode', 'payment','data'],
    components: {
        Head, Link, TextInput, DiscountButton, LoadingButton
    },
    data() {
        return {
            formDiscount: this.$inertia.form({
                code: '',
            }),
            form: this.$inertia.form({
                code: '',
            }),
        }
    },
    methods: {
        storeDiscount() {
            this.formDiscount.post('/discount', {
                onSuccess: (data) => {
                },
            })
        },
        storeOnlinePayment() {
            this.form.code = this.discountCode;
            this.form.post('/online-payment', {
                onSuccess: (data) => {

                },
            })
        },
    },
    created() {
        if (this.packages.total === 0 && this.paymentByCouponOrWallet !== true){
            window.location.href = '/profile';
        }
    },
    updated() {
        if (this.redirect && this.paymentByCouponOrWallet !== true) {
            window.location.href = this.redirect;
        }
        if(this.data != null ) {
            const form = document.getElementById('sebForm');
                if (form) {
                    form.submit(); // Submit the form when data is not null
                }
        }
    },
    layout: LayoutFirstRegister,
    metaInfo() {
        return {
            meta: []
        }
    }
}
</script>

<style scoped>

</style>
